import { inject, Injectable } from '@angular/core';
import { PollingAbstractService } from '../../shared/services/abstract/polling.abstract.service';
import { JobStatus } from '../../shared/models/generated/ziroModels';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class MigrationsNumbersPollingContext extends PollingAbstractService<JobStatus> {
  private _route = inject(ActivatedRoute);

  baseUrl = `/services/microsoft/migrations/tenants/${this._route.snapshot.params.tenantId}/exports/${this._route.snapshot.data['pbxType']}/${this._route.snapshot.params.id}/number-report/status`;
}
